import { Config, Helpers as CoreHelpers, IFinalResponse, InitializeTypes } from '@smiles/core-engine';
import type { APIEnvs } from '@smiles/core-engine/dist/types';
import { Services as CoreServices } from '@smiles/core-utils';

let { smlsEnv, isDotEnv } = window;

if (smlsEnv.includes('uat')) {
  smlsEnv = smlsEnv.replace(/uat/, 'hml');
}

const ENV_CORE = (`${smlsEnv?.toLocaleUpperCase() + (isDotEnv ? '-N' : '')}` || 'MOCK') as APIEnvs;

const configLib: InitializeTypes = {
  service: {
    logger: false,
    timeout: 60000,
    environment: ENV_CORE,
    region: 'Brasil',
  },
  channel: 'WEB',
  receiveConstants: true,
  loggerXstate: false,
};

export function init() {
  return Config.initialize(configLib);
}

export { Config, CoreHelpers, CoreServices };
export type { IFinalResponse };
